import { AlpineComponent } from 'alpinejs';

type ImageBreakData = {}

export default ():AlpineComponent<ImageBreakData> => ({
  init() {
    this.$lazyLoad.update();

    const videoEl = document.querySelectorAll('.ce-image-break--media');
    if (videoEl.length != 0) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Pause all other videos
            const videos = document.querySelectorAll(".ce-image-break-video");
            if (videos) {
              videos.forEach((video) => {
                (video as HTMLVideoElement).pause();
              });
            }
            // Play video
            const video = entry.target.querySelector('.ce-image-break-video');
            if (video) {
              (video as HTMLVideoElement).play();
              observer.disconnect();
            }
          }
        });
      }, { rootMargin: '-50% 0%' });

      const elementsToObserve = new Set([ ...document.querySelectorAll('.ce-image-break--media') ]);
      elementsToObserve.forEach((element) => {
        if (element) {
          observer.observe(element);
        }
      });
    }
  },
});
